import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function FeaturedCases() {
  const { t } = useTranslation();

  const featuredArticles = articles.filter((a) => a.featured).slice(0, 4);

  const categoryNames: Record<string, string> = {
    'short-video': t('categoryShortVideo'),
    'brand-marketing': t('categoryBrandMarketing'),
    'ad-planning': t('categoryAdPlanning'),
    'social-media': t('categorySocialMedia'),
    'content-creative': t('categoryContentCreative'),
    'full-service': t('categoryFullService'),
  };

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12 md:mb-16">
            <div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">{t('caseTitle')}</h2>
              <p className="text-sm md:text-base text-foreground-600">{t('caseDesc')}</p>
            </div>
            <Link
              to="/category/short-video"
              className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span>{t('viewAll')}</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {featuredArticles.map((article) => {
              const cat = categories.find((c) => c.slug === article.category);
              return (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="flex flex-col sm:flex-row">
                    <div className="w-full sm:w-48 h-48 sm:h-auto flex-shrink-0 overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="flex-1 p-5 md:p-6 flex flex-col justify-between">
                      <div>
                        <div className="flex items-center gap-3 mb-3 flex-wrap">
                          <span className="text-xs font-medium px-2.5 py-1 bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                            {categoryNames[article.category] || article.category}
                          </span>
                          <span className="text-xs text-foreground-500">{article.date}</span>
                          <span className="text-xs text-foreground-500">{article.readTime}</span>
                        </div>
                        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                          {article.title}
                        </h3>
                        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                          {article.excerpt}
                        </p>
                      </div>
                      <div className="flex items-center gap-2 mt-4 text-sm text-primary-600 font-medium">
                        <span>{t('readMore')}</span>
                        <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-0.5"></i>
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}